import { render, staticRenderFns } from "./PopupPartnerAgreementAdd.vue?vue&type=template&id=764fea6a&scoped=true&"
import script from "./PopupPartnerAgreementAdd.vue?vue&type=script&lang=js&"
export * from "./PopupPartnerAgreementAdd.vue?vue&type=script&lang=js&"
import style0 from "./PopupPartnerAgreementAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764fea6a",
  null
  
)

export default component.exports